import axios from "../axios";
// 获取学科列表
export const getSubList = (data) => {
  return axios({
    url: "/console/school_subject/enable_list",
    method: "GET",
    data: data,
  });
};

// 添加教师
export const addTeacher = (data) => {
  return axios({
    url: "/console/teacher/save",
    method: "POST",
    data,
  });
};

// 教师详情
export const getMemberInfo = (data) => {
  return axios({
    url: "/console/teacher/getTeacherDetail",
    method: "GET",
    data: data,
  });
};

// 移除教师
export const delTeacher = (data) => {
  return axios({
    url: "/console/teacher/removeTeacher",
    method: "POST",
    data,
  });
};

// 学生列表
export const getStudentList = (data) => {
  return axios({
    url: "/console/parent/pageByHomeworkClass",
    method: "GET",
    data: data,
  });
};

// 学生详情查看
export const getStudentInfo = (data) => {
  return axios({
    url: "/console/parent/classDetail",
    method: "GET",
    data: data,
  });
};

// 移除学生
export const delStudent = (data) => {
  return axios({
    url: "/console/parent/removeParentByClass",
    method: "GET",
    data: data,
  });
};

// 添加学生
export const addStudent = (data) => {
  return axios({
    url: "/console/parent/save",
    method: "POST",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/memberManagement.js